import { useCallback, useMemo } from 'react';
import { useCurrentUserProfile } from 'src/graphql/entities/platform-user';
import {
  useCreateUserSettingValue,
  UserSettingId,
  useUpdateUserSettingValue,
} from 'src/graphql/entities/user-setting-value';

export function useConversationAttachmentsVisibility() {
  const { user } = useCurrentUserProfile();
  const currentVisibility = useMemo(
    () => user?.userSettingValueMap.get(UserSettingId.ConversationAttachmentsVisibility),
    [user?.userSettingValueMap],
  );

  const { createUserSettingValue } = useCreateUserSettingValue();
  const { updateUserSettingValue } = useUpdateUserSettingValue();

  const changeConversationAttachmentsVisibility = useCallback(
    (isVisible: boolean) => {
      const value = isVisible ? 'true' : 'false';

      if (currentVisibility) {
        updateUserSettingValue(currentVisibility.userSettingValue, {
          value,
        });
      } else {
        createUserSettingValue({
          userSettingId: UserSettingId.ConversationAttachmentsVisibility,
          value,
          valueType: 'boolean',
        });
      }
    },
    [createUserSettingValue, currentVisibility, updateUserSettingValue],
  );

  return useMemo(
    () => ({
      changeConversationAttachmentsVisibility,
      currentConversationAttachmentsVisibility: !!currentVisibility?.value,
    }),
    [changeConversationAttachmentsVisibility, currentVisibility?.value],
  );
}
